/**
 * @desc 删除领用详情
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** id */
  id: number;
}

export function request(params: Params): Promise<defs.StandardReturn<string>> {
  return defHttp.get({
    url: '/web/labour/deleteDeliveryDetail',

    params,
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<string>> {
  return defHttp.get({
    url: '/mock/web/labour/deleteDeliveryDetail',

    params,
  });
}
